// The location bar under the panel's header, on a brand with several locations (D4). Wording from the Amigo design's
// copy sheet (Location bar).
export default {
  label: 'Locație',
  all_one: 'Toate cele {{count}} locații',
  all_few: 'Toate cele {{count}} locații',
  all_other: 'Toate cele {{count}} locații',
};
